const config = {
  apiHost: import.meta.env.VITE_APP_API_HOST,
  intercomId: import.meta.env.VITE_APP_INTERCOM_APP_ID,
  algoliaAppId: import.meta.env.VITE_APP_ALGOLIA_APP_ID,
  placesApiKey: import.meta.env.VITE_APP_PLACES_API_KEY,
  streamApiKey: import.meta.env.VITE_APP_STREAM_KEY,
  sentryDsn: import.meta.env.VITE_APP_SENTRY_DSN,
  environment: import.meta.env.VITE_APP_ENV,
  posthog: {
    key: "phc_YnmF3UL5yq2sxfQNbxxSmfC2bmeZumDpofkSXEHB8bj",
    host: "https://us.i.posthog.com"
  }
};

export default config;
